<template>
  <div class="floor-wrap" :style="mainWrapClass">
    <div class="video-page-wrap">
      <div class="video-wrap" :style="videoWrapClass">
        <div class="bar"></div>
        <div class="video-comp">
          <video-component
            :orientation="orientation"
            :controller="items"
            :links="currentVideos"
            :loop-links="currentLoops"
            :key="Number(currentFloor)"
            @open-modal="openModal"
            :style="videoCompClass"
          ></video-component>
        </div>
        <div class="bar"></div>
      </div>
    </div>
    <div v-if="fairConfig.FC_ORANGE == 1" class="booths">
      <booth-display :allbooths="booths" />
    </div>
    <div class="floor-html" v-if="floorHtml" v-html="floorHtml"></div>
    <div class="custom-wrap" v-if="htmlArray.length > 0">
      <div
        class="custom-item"
        v-for="item in htmlArray"
        :key="item"
        v-html="item"
      ></div>
    </div>
  </div>
</template>

<script>
import cssFix from '../mixins/cssFix'
import VideoComponent from '@/components/video/VideoComponent'
import boothDisplay from '@/components/floor/BoothsOnThisFloor'
import api from '@/api'
import { mapState } from 'vuex'
export default {
  components: {
    VideoComponent,
    boothDisplay,
  },
  props: {
    videoLinks: Array,
    orientation: Boolean,
  },
  mixins: [cssFix],
  data() {
    return {
      items: [],
      booths: [],
      htmlArray: [],
      floorHtml: null,
    }
  },
  computed: {
    ...mapState(['fairConfig']),
    currentFloor() {
      return this.$route.params.floor
    },
    currentVideos() {
      let currentLtpCode = 'expi'
      return this.videoLinks.filter(
        (el) =>
          el.ltp_code === currentLtpCode && el.loc_id == this.currentFloor,
      )
    },
    currentLoops() {
      let loopLtpCode = 'expl'
      return this.videoLinks.filter(
        (el) => el.ltp_code === loopLtpCode && el.loc_id == this.currentFloor,
      )
    },
  },
  watch: {
    $route: function () {
      this.init()
    },
  },
  mounted() {
    this.init()
    this.addLogicForCssFix()
  },
  methods: {
    async init() {
      this.startLoading()
      this.items = []
      await this.boothHtml()
      await this.getFloorHtml()
      await this.getCurrentFloorController()
      api.mixpanel({
        event: 'clicked_expo_room_link',
      })
      this.postEventTracking({ code: 'enter_expo', data: this.$route.path })
      this.stopLoading()
    },
    // async postEventTracking() {
    //   try {
    //     const res = await api.postTracking({code:'enter_expo', data: this.$route.path});
    //     console.log(res.data);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async getCurrentFloorController() {
      let transformControllerApi = (arr) => {
        let loc_id = this.currentFloor
        for (const floor of arr) {
          if (floor.loc_id == loc_id) {
            return floor.data
          }
        }
        return []
      }
      let transformBoothsApi = (booths) => {
        let validBooths = []
        for (const booth of booths) {
          if (booth.loc_name && booth.loc_fullname) {
            validBooths.push(booth)
          }
        }
        return validBooths
      }
      try {
        let res = await api.getFloorsElements()
        this.items = transformControllerApi(res.data.res)
        this.booths = transformBoothsApi(res.data.booths)
      } catch (error) {
        this.handleError(error)
      }
    },
    async getFloorHtml() {
      try {
        let res = await api.getFloorHtml()
        if (res.data.html) {
          this.floorHtml = res.data.html
        }
      } catch (error) {
        // console.log(error)
      }
    },
    async boothHtml() {
      for (const item of this.items) {
        try {
          let res = await api.getBoothHtml(item.link.replace('/booth/', ''))
          if (res && res.data && res.data.html) {
            this.htmlArray.push(res.data.html)
          }
        } catch (error) {
          // console.log(error)
        }
      }
      if (this.htmlArray.length > 0) {
        this.htmlArray = [...this.htmlArray]
      }
    },
    openModal(link) {
      this.$emit('open-modal', link)
    },
  },
  async beforeRouteUpdate(to, from, next) {
    const loc_id = to.params.id
    if (await api.checkPermission({ loc_id })) next()
    else {
      this.EventBus.$emit('error', this.$t('noPermission'))
      next(from.path)
    }
  },
}
</script>

<style scoped lang="scss">
.custom-wrap,
.floor-html {
  display: flex;
  flex-wrap: wrap;
  padding: 0 5%;
  box-sizing: border-box;
  margin-top: 50px;
  justify-content: center;
}
.booth-logo-wrap {
  max-width: 50%;
}
</style>
